import { useLocation } from 'react-router-dom';
import CRUDReadFilteredPage from '../page/crud/CRUDReadFilteredPage';
import CRUDFormPage from '../page/crud/CRUDFormPage';
import { ROUTE_TYPE_CRUD } from './route-constants';
import CRUDDetailPage from '../page/crud/CRUDDetailPage';
import CRUDDetailDialog from '../page/crud/CRUDDetailDialog';

export const getFlattenRoutes = (routes) => {
  const flattenRoutes = [];
  routes.map((route) => {
    if (route.type === ROUTE_TYPE_CRUD) {
      // index
      const { index: indexOptions } = route.crudOptions;
      if (indexOptions.enabled) {
        const { Component, componentProps, ...index } = route.routes.index;
        const IndexComponent = Component || CRUDReadFilteredPage;
        flattenRoutes.push({
          Component: IndexComponent,
          componentProps: {
            routes: route.routes,
            crudOptions: route.crudOptions,
            ...componentProps,
          },
          ...index,
        });
      }

      // detail
      const { detail: detailOptions } = route.crudOptions;
      if (detailOptions.enabled) {
        if (detailOptions.type === 'routeDialog' || detailOptions.type === 'route') {
          const {
            Component, ComponentContent, componentProps, ...detail
          } = route.routes.detail;
          const DetailComponent = Component || CRUDDetailPage;
          flattenRoutes.push({
            Component: DetailComponent,
            componentProps: {
              ComponentContent,
              routes: route.routes,
              crudOptions: route.crudOptions,
              ...componentProps,
            },
            ...detail,
          });
        }
      }

      // create
      const { create: createOptions } = route.crudOptions;
      if (createOptions.enabled) {
        const { Component, componentProps: cpCreate, ...create } = route.routes.create;
        const CreateComponent = Component || CRUDFormPage;
        flattenRoutes.push({
          Component: CreateComponent,
          componentProps: {
            routes: route.routes,
            ...cpCreate,
          },
          ...create,
        });
      }

      // edit
      const { edit: editOptions } = route.crudOptions;
      if (editOptions.enabled) {
        const { Component, componentProps: cpEdit, ...edit } = route.routes.edit;
        const EditComponent = Component || CRUDFormPage;
        flattenRoutes.push({
          Component: EditComponent,
          componentProps: {
            routes: route.routes,
            ...cpEdit,
          },
          ...edit,
        });
      }
    } else {
      // Add non-CRUD routes directly.
      flattenRoutes.push(route);
    }
    return null;
  });
  return flattenRoutes;
};

// TODO: Update this
export const getRouteDialogs = (routes) => {
  const routeDialogs = [];
  routes.map((route) => {
    if (route.componentType === 'routeDialog') {
      routeDialogs.push(route);
    }
    if (route.type === ROUTE_TYPE_CRUD) {
      const { detail: detailOptions } = route.crudOptions;
      if (detailOptions.enabled) {
        if (detailOptions.type === 'routeDialog') {
          const {
            ComponentDialog, ComponentContent, componentProps, ...detail
          } = route.routes.detail;
          const DetailComponent = ComponentDialog || CRUDDetailDialog;
          routeDialogs.push({
            ComponentDialog: DetailComponent,
            componentProps: {
              ComponentContent,
              routes: route.routes,
              crudOptions: route.crudOptions,
              ...componentProps,
            },
            ...detail,
          });
        }
      }
    }
    return null;
  });
  return routeDialogs;
};

export const useSearchParams = () => new URLSearchParams(useLocation().search);
